import React from 'react';

import {MapType} from 'constants/MapsConstants';
import {ButtonSize} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

const MAP_TYPE_TO_DISPLAY: Record<MapType, string> = {
  [MapType.PLASMID]: 'Plasmid map',
  [MapType.LINEAR_SEQUENCE]: 'Sequence map',
  [MapType.MINIMAP]: 'Linear map',
};

export interface MapSelectorProps {
  mapType: MapType;
  onSelectMapType: (mapType: MapType) => void;
  isCircular: boolean;
}

export default function MapSelector({mapType, onSelectMapType, isCircular}: MapSelectorProps): JSX.Element {
  const mapTypeOptions = isCircular
    ? [MapType.LINEAR_SEQUENCE, MapType.PLASMID, MapType.MINIMAP]
    : [MapType.LINEAR_SEQUENCE, MapType.MINIMAP];

  return (
    <SelectDropdown
      displayName={`View: ${MAP_TYPE_TO_DISPLAY[mapType]}`}
      buttonSize={ButtonSize.MINI}
      menu={
        <Menu width={MenuWidth.FULL}>
          {mapTypeOptions.map((mapTypeOption) => (
            <Option key={mapTypeOption} value={mapTypeOption} onSelect={onSelectMapType}>
              {MAP_TYPE_TO_DISPLAY[mapTypeOption]}
            </Option>
          ))}
        </Menu>
      }
    />
  );
}
